import script from "./TemplateLibraryView.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateLibraryView.vue?vue&type=script&setup=true&lang=js"

import "./TemplateLibraryView.vue?vue&type=style&index=0&id=473e2e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473e2e66"]])

export default __exports__